import React, { useState, useEffect, useRef } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAlignLeft, faAlignRight, faAlignJustify, faAlignCenter, faTextHeight, faList, faTable, faImage, faFont, faPrint } from '@fortawesome/free-solid-svg-icons';

//Css
import '../../assets/css/RichTextEditor.css';

//Components
import ButtonEditor from './Components/ButtonEditor';
import InputEditor from './Components/InputEditor/Index';

//Helpers
import useModal from './helpers/useModal';
import useForm from './helpers/useForm';
import { selectStyle } from './helpers/selection';
import uuid from '../../helpers/guid';

function RichTextEditor({ name, value, onChange = () => { }, invalid, disabled, saveImage }) {
    const refFileInput = useRef();
    //Estado do conteudo do editor
    const [conteudo, setConteudo] = useState(value);

    //Utilizando a hook personalizada para o formulario de imagem
    const [imageForm, errorsImageForm, onChangeImageFields, resetImageForm] = useForm({
        url: "",
        base64: "",
        background: false,
        width: "",
        height: ""
    });

    //Função para inserção de imagens
    const imageInsert = () => {
        const mainDiv = document.getElementById("main");

        // Confere se o imageForm possui a opção de background ativo para definir o background da div principal
        const element = { id: uuid(), tag: "img", base64: null, background: false };
        if (imageForm.background) {

            const backgroundDiv = document.createElement("div");

            backgroundDiv.id = element.id;
            element.background = true;
            backgroundDiv.style.backgroundImage = `url(${imageForm.base64})`;
            backgroundDiv.innerHTML = "Insira aqui o conteudo";
            // Inserindo o elemento <img> no local do cursor
            if (rangeSelection)
                rangeSelection.range.insertNode(backgroundDiv);
            element.base64 = imageForm.base64;
            if (saveImage)
                saveImage(element.base64,{ target: { name, value: document.getElementById("main").innerHTML } });

        } else {
            const imgElement = document.createElement('img');
            imgElement.alt = "";
            if (imageForm.url != "") {
                imgElement.src = imageForm.url;
            } else if (imageForm.base64 != "") {
                imgElement.src = imageForm.base64;
                element.base64 = imageForm.base64;
                if (saveImage)
                    saveImage(imageForm.base64,{ target: { name, value: document.getElementById("main").innerHTML } });
            } else {
                return;
            }

            imgElement.style.width = `${imageForm.width}px`;
            imgElement.style.height = `${imageForm.height}px`;

            // Inserindo o elemento <img> no local do cursor
            if (rangeSelection) {
                const node = document.getElementById(rangeSelection.node.id);
                const focusNode = document.getElementById(rangeSelection.focusNode.id);

                if (node === mainDiv || focusNode === mainDiv || mainDiv.contains(node) || mainDiv.contains(focusNode))
                    rangeSelection.range.insertNode(imgElement);
            }

        }

        toggleVisibleModalImage();
        setRangeSelection(null);
        resetImageForm();
        setElements([...elements, element]);
    }

    //Utilizando a hook personalizada para o formulario de tabela
    const [tableForm, errorsTableForm, onChangeTableForm, resetTableForm] = useForm({
        linhas: "",
        colunas: "",
        borda: "",
        linhaDeTitulos: false,
        coresAlternadas: false,
    });

    //Função de inserção da tabela na tela
    const tableInsert = () => {
        if (tableForm.linhas !== "" && tableForm.colunas !== "") {
            const newNodeTable = document.createElement("table");
            newNodeTable.style.width = "100%";
            newNodeTable.style.borderCollapse = "collapse";
            if (tableForm.borda != "")
                newNodeTable.style.border = `${tableForm.borda}px solid #000`;

            const linhas = parseInt(tableForm.linhas);
            const colunas = parseInt(tableForm.colunas);

            for (let i = 0; i < linhas; i++) {
                const newTableRow = document.createElement('tr');

                //Conferindo se as cores das linhas tem que estar alternadas
                if (tableForm.coresAlternadas && i % 2 == 0)
                    newTableRow.style.backgroundColor = "#bdc3c7";

                for (let j = 0; j < colunas; j++) {
                    //Conferindo se é necessario a linha de titulos da tabela
                    if (tableForm.linhaDeTitulos && i == 0) {
                        const newTableHeader = document.createElement('th');
                        if (tableForm.borda != "")
                            newTableHeader.style.border = `${tableForm.borda}px solid #000`;

                        newTableHeader.textContent = "Titulo " + j;
                        newTableRow.appendChild(newTableHeader);

                    } else {
                        const newTableData = document.createElement('td');
                        if (tableForm.borda != "")
                            newTableData.style.border = `${tableForm.borda}px solid #000`;

                        newTableData.textContent = "Item " + j;
                        newTableRow.appendChild(newTableData);
                    }

                }

                newNodeTable.appendChild(newTableRow);
            }

            // Inserindo a tabela na seleção
            if (rangeSelection)
                rangeSelection.range.insertNode(newNodeTable);

            toggleVisibleModalTabela();
            setRangeSelection(null);
            resetTableForm();
            onChange({ target: { name, value: document.getElementById("main").innerHTML } });
        }
    }

    //change para o campod de base64 da imagem
    const onChangeFileImage = (e) => {
        const FR = new FileReader();

        FR.addEventListener("load", function (evt) {
            onChangeImageFields({ target: { name: "base64", value: evt.target.result } });
        });
        if (e.target.files)
            FR.readAsDataURL(e.target.files[0]);
    };

    //Variavel que guarda os valores a serem apresentados na opção de titulo
    const texts = [
        { Label: () => <p style={{ fontSize: '46pt' }}>Title</p>, tag: "span", type: "fontSize", value: "46pt" },
        { Label: () => <p style={{ fontSize: '40pt' }}>Title</p>, tag: "span", type: "fontSize", value: "40pt" },
        { Label: () => <p style={{ fontSize: '32pt' }}>Title</p>, tag: "span", type: "fontSize", value: "32pt" },
        { Label: () => <p style={{ fontSize: '26pt' }}>Title</p>, tag: "span", type: "fontSize", value: "26pt" },
        { Label: () => <p style={{ fontSize: '20pt' }}>Title</p>, tag: "span", type: "fontSize", value: "20pt" },
        { Label: () => <p style={{ fontSize: '14pt' }}>Title</p>, tag: "span", type: "fontSize", value: "14pt" },
        { Label: () => <p style={{ fontSize: '12pt' }}>Title</p>, tag: "span", type: "fontSize", value: "12pt" },
    ];

    //Variavel que guarda os valores a serem apresentados na opção de titulo
    const fonts = [
        { Label: () => <p style={{ fontSize: '14pt', fontFamily: "Arial" }}>Title</p>, tag: "span", type: "fontFamily", value: "Arial" },
        { Label: () => <p style={{ fontSize: '14pt', fontFamily: "Helvetica" }}>Title</p>, tag: "span", type: "fontFamily", value: "Helvetica" },
        { Label: () => <p style={{ fontSize: '14pt', fontFamily: "Times New Roman" }}>Title</p>, tag: "span", type: "fontFamily", value: "Times New Roman" },
        { Label: () => <p style={{ fontSize: '14pt', fontFamily: "Times" }}>Title</p>, tag: "span", type: "fontFamily", value: "Times" },
        { Label: () => <p style={{ fontSize: '14pt', fontFamily: "Courier New" }}>Title</p>, tag: "span", type: "fontFamily", value: "Courier New" },
        { Label: () => <p style={{ fontSize: '14pt', fontFamily: "Courier" }}>Title</p>, tag: "span", type: "fontFamily", value: "Courier" },
        { Label: () => <p style={{ fontSize: '14pt', fontFamily: "Georgia" }}>Title</p>, tag: "span", type: "fontFamily", value: "Georgia" },
        { Label: () => <p style={{ fontSize: '14pt', fontFamily: "Verdana" }}>Title</p>, tag: "span", type: "fontFamily", value: "Verdana" },
        { Label: () => <p style={{ fontSize: '14pt', fontFamily: "Tahoma" }}>Title</p>, tag: "span", type: "fontFamily", value: "Tahoma" },
        { Label: () => <p style={{ fontSize: '14pt', fontFamily: "Trebuchet MS" }}>Title</p>, tag: "span", type: "fontFamily", value: "Trebuchet MS" },
        { Label: () => <p style={{ fontSize: '14pt', fontFamily: "Lucida Grande" }}>Title</p>, tag: "span", type: "fontFamily", value: "Lucida Grande" },
    ];

    //Função que pega o range da seleção
    const getRangeSelection = () => {
        const selection = window.getSelection();
        if (selection && selection.rangeCount) {
            const parentElement = selection?.anchorNode?.parentElement;
            const focusNode = selection?.anchorNode;
            setRangeSelection({
                range: selection.getRangeAt(0).cloneRange(),
                node: parentElement ? parentElement.cloneNode() : null,
                focusNode: focusNode ? focusNode.cloneNode() : null,
                nodeContent: parentElement ? parentElement.textContent : null,
                selectionText: selection.toString()
            });
        }
    }

    //Estado de controle para exibição do modal dos textos
    const [visibleModalFonts, toggleVisibleModalFonts] = useModal();

    //Estado de controle para exibição do modal dos textos
    const [visibleModalText, toggleVisibleModalText] = useModal();

    //Estado de controle para exibição do modal de inserção da imagem
    const [visibleModalImage, toggleVisibleModalImage] = useModal();

    //Estado de controle para exibição do modal de inserção de tabela
    const [visibleModalTabela, toggleVisibleModalTabela] = useModal();

    //Seleção ao clicar no botão com modal
    const [rangeSelection, setRangeSelection] = useState(null);

    //ids dos elementos do conteudo
    const [elements, setElements] = useState([]);

    //Função de onclick das ações de edição de texto
    const onClickActions = ({ tag, type, value, cancelValue }) => {
        const element = selectStyle({ tag: tag, type: type, value: value, cancelValue: cancelValue, rangeSelection, setRangeSelection });
        if (element) {
            setElements([...elements, element]);
        }
    }

    useEffect(() => {
        const editableDiv = document.getElementById('main');

        editableDiv.addEventListener('keydown', (event) => {
            // Verificar se a tecla pressionada é o "Enter"
            if (event.key === "Enter") {
                // Impedir que a tecla "Enter" insira uma nova linha padrão
                event.preventDefault();

                // Criar um elemento <br> para representar a quebra de linha
                const brElement = document.createElement('br');

                // Inserir o elemento <br> no lugar do "Enter" pressionado
                const selection = window.getSelection();
                const range = selection.getRangeAt(0);
                range.deleteContents();
                range.insertNode(brElement);
                range.setStartAfter(brElement);
                range.setEndAfter(brElement);

                // Mover o cursor para depois do elemento <br>
                selection.removeAllRanges();
                selection.addRange(range);
            }
        });

    }, []);
    return (
        <div className="main-width">
            <div className='options-editor'>
                <div className='group-options no-border'>
                    <div style={{ position: "relative" }}>
                        <ButtonEditor color="primary" style={{ fontWeight: "bold" }} onClick={() => toggleVisibleModalFonts(getRangeSelection)}><FontAwesomeIcon icon={faFont} /> </ButtonEditor>
                        <div className={`modalSelect ${visibleModalFonts ? "" : "close"}`}>
                            {
                                fonts.map((value, index) => {
                                    const Component = value.Label;

                                    return <span className='btn' key={index} onClick={() => {
                                        onClickActions({ tag: value.tag, type: value.type, value: value.value, cancelValue: "Arial" });
                                        toggleVisibleModalFonts();
                                        setRangeSelection(null);
                                    }}>
                                        <Component />
                                    </span>
                                })
                            }
                        </div>
                    </div>
                    <div style={{ position: "relative" }}>
                        <ButtonEditor color="primary" style={{ fontWeight: "bold" }} onClick={() => toggleVisibleModalText(getRangeSelection)}><FontAwesomeIcon icon={faTextHeight} /> </ButtonEditor>
                        <div className={`modalSelect ${visibleModalText ? "" : "close"}`}>
                            {
                                texts.map((value, index) => {
                                    const Component = value.Label;

                                    return <span className='btn' key={index} onClick={() => {
                                        onClickActions({ tag: value.tag, type: value.type, value: value.value, cancelValue: "12pt" });
                                        toggleVisibleModalText();
                                        setRangeSelection(null);
                                    }}>
                                        <Component />
                                    </span>
                                })
                            }
                        </div>
                    </div>
                </div>
                <div className='group-options'>
                    <ButtonEditor color="primary" style={{ fontWeight: "bold" }} onClick={() => onClickActions({ tag: "p", type: "textAlign", value: "left", cancelValue: 'normal' })}><FontAwesomeIcon icon={faAlignLeft} /> </ButtonEditor>
                    <ButtonEditor color="primary" style={{ fontWeight: "bold" }} onClick={() => onClickActions({ tag: "p", type: "textAlign", value: "right", cancelValue: 'normal' })}><FontAwesomeIcon icon={faAlignRight} /> </ButtonEditor>
                    <ButtonEditor color="primary" style={{ fontWeight: "bold" }} onClick={() => onClickActions({ tag: "p", type: "textAlign", value: "center", cancelValue: 'normal' })}><FontAwesomeIcon icon={faAlignCenter} /> </ButtonEditor>
                    <ButtonEditor color="primary" style={{ fontWeight: "bold" }} onClick={() => onClickActions({ tag: "p", type: "textAlign", value: "justify", cancelValue: 'normal' })}><FontAwesomeIcon icon={faAlignJustify} /> </ButtonEditor>
                </div>
                <div className='group-options'>
                    <ButtonEditor color="primary" style={{ fontWeight: "bold" }} onClick={() => onClickActions({ tag: "span", type: "fontWeight", value: "bold", cancelValue: 'normal' })}>N</ButtonEditor>
                    <ButtonEditor color="primary" style={{ textDecoration: "underline" }} onClick={() => onClickActions({ tag: "span", type: "textDecoration", value: "underline", cancelValue: 'none' })}>U</ButtonEditor>
                    <ButtonEditor color="primary" style={{ fontStyle: "italic" }} onClick={() => onClickActions({ tag: "span", type: "fontStyle", value: "italic", cancelValue: 'normal' })}>I</ButtonEditor>
                    <ButtonEditor color="primary" style={{ textDecoration: "line-through" }} onClick={() => onClickActions({ tag: "span", type: "textDecoration", value: "line-through", cancelValue: 'none' })}>S</ButtonEditor>
                </div>
                <div className='group-options'>
                    <div style={{ position: "relative" }}>
                        <ButtonEditor color="primary" style={{ textDecoration: "underline" }} onClick={() => {
                            toggleVisibleModalTabela(getRangeSelection, resetTableForm);
                        }
                        }><FontAwesomeIcon icon={faTable} /></ButtonEditor>
                        <div style={{ width: "250px" }} className={`modalSelect ${visibleModalTabela ? "" : "close"}`} >
                            <div style={{ display: "flex", gap: ".5rem" }}>
                                <InputEditor label={"Linhas"} type={"text"} name='linhas' onChange={onChangeTableForm} value={tableForm.linhas} />
                                <InputEditor label={"Colunas"} type={"text"} name='colunas' onChange={onChangeTableForm} value={tableForm.colunas} />
                            </div>
                            <InputEditor label={"Tamanho da borda"} type={"text"} name='borda' onChange={onChangeTableForm} value={tableForm.borda} />
                            <div>
                                <input type='checkbox' name='linhaDeTitulos' onChange={(e) => onChangeTableForm({ target: { name: "linhaDeTitulos", value: e.target.checked } })} checked={imageForm.linhaDeTitulos} />
                                <span>linha de titulos</span>
                            </div>
                            <div>
                                <input type='checkbox' name='coresAlternadas' onChange={(e) => onChangeTableForm({ target: { name: "coresAlternadas", value: e.target.checked } })} checked={imageForm.coresAlternadas} />
                                <span>cores alternadas</span>
                            </div>
                            <ButtonEditor color='success' onClick={tableInsert}>Inserir tabela</ButtonEditor>
                        </div>
                    </div>
                    <div style={{ position: "relative" }}>
                        <ButtonEditor color="primary" style={{ fontWeight: "bold" }} onClick={() => {
                            toggleVisibleModalImage(getRangeSelection, resetImageForm);
                        }
                        }><FontAwesomeIcon icon={faImage} /></ButtonEditor>
                        <div style={{ width: "250px" }} className={`modalSelect ${visibleModalImage ? "" : "close"}`}>
                            <InputEditor label={"Url da imagem"} type={"text"} name='url' onChange={onChangeImageFields} value={imageForm.url} />
                            <div style={{ display: "flex", gap: ".5rem" }}>
                                <InputEditor label={"Largura"} type={"text"} name='width' onChange={onChangeImageFields} value={imageForm.width} />
                                <InputEditor label={"Altura"} type={"text"} name='height' onChange={onChangeImageFields} value={imageForm.height} />
                            </div>
                            <ButtonEditor color='primary' onClick={() => {
                                refFileInput.current.click()
                            }}>Upload de arquivo</ButtonEditor>
                            <input
                                type="file"
                                ref={refFileInput}
                                onChange={onChangeFileImage}
                                style={{ display: "none" }}
                            />
                            <div>
                                <input type='checkbox' name='background' onChange={(e) => onChangeImageFields({ target: { name: "background", value: e.target.checked } })} checked={imageForm.background} />
                                <span>usar como background</span>
                            </div>
                            <ButtonEditor color='success' onClick={imageInsert}>Inserir imagem</ButtonEditor>
                        </div>
                    </div>
                </div>
            </div>
            <div id='main' className={`main-rich-text-editor body ${invalid ? "invalid" : ""}`} contentEditable={!disabled} onInput={(e) => onChange({ target: { name, value: e.target.innerHTML } })} dangerouslySetInnerHTML={{ __html: conteudo }}>

            </div>
        </div >
    );
}

export default RichTextEditor;
